import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-po-finish-po-finish-comps',
  templateUrl: './po-finish-po-finish-comps.component.html',
  styleUrls: ['./po-finish-po-finish-comps.component.css']
})
export class PoFinishPoFinishCompsComponent implements OnInit {
    p2PoFinishKeyno;

    public selectedBgComponentSelection: string = 'MINE';

    public itemsListComponents: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2PoFinishKeyno = this.stateService.getStateParams()['p2_pofinish_keyno'];
    }

    private async loadComponents() {
        if (!!this.p2PoFinishKeyno && !!this.selectedBgComponentSelection) {
            this.itemsListComponents = await this.datatask.Post(487, {
                p2_pofinish_keyno: this.p2PoFinishKeyno,
                who: this.selectedBgComponentSelection
            });
        }
    }

    public onTabChanged() {
        this.loadComponents();
    }

    private async init() {
        this.loadComponents();
    }

    ngOnInit() {
        this.init();
    }
}
